<template>
  <wow-card elevation="0" :show-title="false">
    <div v-if="wowKitData.uploadedProductData.length > 0">
      <v-card-title class="pa-0 pb-1" style="font-size:14px;">Uploaded Product's Data</v-card-title>
      <ProductData :product="wowKitData.uploadedProductData" />
    </div>
    <div v-if="wowKitData.previousBomData.length > 0">
      <v-card-title class="pa-0 pb-1" style="font-size:14px;">Previous BOM Data</v-card-title>
      <ProductData :product="wowKitData.previousBomData" />
    </div>
    <div v-if="wowKitData.newlyAddedProduct.length > 0">
      <v-card-title class="pa-0 pb-1" style="font-size:14px;">Newly added products</v-card-title>
      <ProductData :product="wowKitData.newlyAddedProduct" />
    </div>
    <div v-if="wowKitData.droppedProductData.length > 0">
      <v-card-title class="pa-0 pb-1" style="font-size:14px;">Dropped Product's Data</v-card-title>
      <ProductData :product="wowKitData.droppedProductData" />
    </div>
    <div v-if="bomProductData.length > 0">
      <v-card-title class="pa-0 pb-1" style="font-size:14px;">BOM Quantity Updated Product's Data</v-card-title>
      <UpdatedBomProductQuantity :product="bomProductData" />
    </div>
    <v-row>
      <v-col
        v-if="
        ((WOWKIT_MAKER && rejectReasonText !== '' && rejectReasonText) ||
        (C1_APPROVED && rejectReasonText !== '' && rejectReasonText) ||
        (C2_APPROVED && rejectReasonText !== '' && rejectReasonText) ||
        (C3_APPROVED && rejectReasonText !== '' && rejectReasonText))
        "
        cols="12"
        md="4"
        lg="4"
        xs="12"
        sm="6"
      >
        <wow-reject outlined :disabled="(WOWKIT_MAKER || C1_APPROVED || C2_APPROVED || C3_APPROVED)" v-model="rejectReasonText" :rejectEmail="rejectedEmailId"></wow-reject>
      </v-col>
    </v-row>
    <v-card-actions v-if="activeRejectAction" class="d-flex justify-end">
      <v-btn @click.prevent="approveBOMKitConfiguration('APPROVED')" small class="success">
        <v-icon small>mdi-check</v-icon><span class="ml-1">Approve</span>
      </v-btn>
      <v-btn @click.prevent="wowKitRejectPopup" small class="error">
        <v-icon small>mdi-block-helper</v-icon><span class="ml-1">Reject</span>
      </v-btn>
    </v-card-actions>
    <wow-dialog :fullscreen="false" :title="`Rejection Reason`" v-model="rejectResonDialog" :persistent="true"
      @close="closeRejectReasonDialog" width="600">
      <v-card>
        <v-card-text>
          <wow-reject :disabled="WOWKIT_MAKER" outlined v-model="rejectReason" :hideDetails="true"
            :rejectedBy="false"></wow-reject>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn @click="rejectBOMKitCOnfiguration('REJECTED')" small class="error">
            <v-icon small>mdi-block-helper</v-icon>
            <span class="ml-1">Reject</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </wow-dialog>
  </wow-card>
</template>
<script>
import Utils from '@/utils'
import _ from 'lodash'
import CONSTANTS from '@/utils/constants'
import WowCard from '@/components/Orders/WowKitOrdering/kitComponents/vCard'
import WowReject from '@/components/Orders/WowKitOrdering/kitComponents/reason/rejectReason'
import ProductData from '@/components/Orders/WowKitOrdering/kitComponents/table/productData'
import UpdatedBomProductQuantity from '@/components/Orders/WowKitOrdering/kitComponents/table/updatedBomProductQuantity'
import WowDialog from '@/components/Orders/WowKitOrdering/kitComponents/dialog/dialogComponent'
export default {
  name: 'viewProductDetail',
  components: {
    WowCard,
    WowReject,
    ProductData,
    UpdatedBomProductQuantity,
    WowDialog
  },
  props: {
    wowKitSetModalMapObj: {
      type: Object,
      default: () => { }
    },
    viewDetailsDialog: {
      type: Boolean,
      default: false
    },
    C1_APPROVED: {
      type: Boolean,
      default: false
    },
    C2_APPROVED: {
      type: Boolean,
      default: false
    },
    C3_APPROVED: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      rejectReason: '',
      rejectReasonText: '',
      rejectedEmailId: '',
      wowKitSetId: null,
      model: null,
      wowKitData: {
        uploadedProductData: [],
        previousBomData: [],
        newlyAddedProduct: [],
        droppedProductData: []
      },
      bomProductData: [],
      WOWKIT_MAKER: this.checkModuleAccess('WOW_KIT_MAKER'),
      activeRejectAction: false,
      rejectResonDialog: false
    }
  },
  watch: {
    wowKitSetModalMapObj: {
      handler: async function (newVal) {
        this.wowKitSetId = newVal.wowKitSetModalMapID
        this.model = newVal.model
        await this.getViewDetalsProductData()
      },
      deep: true
    },
    viewDetailsDialog: function (newVal) {
      if (!newVal) {
        this.rejectReason = ''
      }
    }
  },
  async created () {
    this.wowKitSetId = this.wowKitSetModalMapObj.wowKitSetModalMapID
    this.model = this.wowKitSetModalMapObj.model
    await this.getViewDetalsProductData()
    await this.isApproveRejectItem()
  },
  methods: {
    isApproveRejectItem: function () {
      if (this.C1_APPROVED && this.wowKitSetModalMapObj.status === CONSTANTS.WOW_KIT_BOM_APPROVER_LABEL.pending) {
        this.activeRejectAction = true
      } else if (this.C2_APPROVED && this.wowKitSetModalMapObj.status === CONSTANTS.WOW_KIT_BOM_APPROVER_LABEL.c1Approve) {
        this.activeRejectAction = true
      } else if (this.C3_APPROVED && this.wowKitSetModalMapObj.status === CONSTANTS.WOW_KIT_BOM_APPROVER_LABEL.c2Approve) {
        this.activeRejectAction = true
      } else {
        this.activeRejectAction = false
      }
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    wowKitRejectPopup: function () {
      this.rejectReason = ''
      this.rejectResonDialog = true
    },
    approveBOMKitConfiguration: async function (type) {
      this.$dialog.confirm({
        title: 'Approve wow kit bom configuration',
        text: 'Are you sure you want to <b>approve</b> wow kit bom configuration?',
        actions: {
          false: {
            text: 'No',
            handle: () => {
              this.$nextTick(() => {
                return false
              })
            }
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                let payload = {}
                payload.kitSetID = this.wowKitSetId
                if (this.C1_APPROVED) {
                  payload.chLevel = 'C1'
                  payload.status = (type === 'APPROVED') ? CONSTANTS.WOW_KIT_BOM_APPROVER_LABEL.c1Approve : CONSTANTS.WOW_KIT_BOM_APPROVER_LABEL.rejected
                } else if (this.C2_APPROVED) {
                  payload.chLevel = 'C2'
                  payload.status = (type === 'APPROVED') ? CONSTANTS.WOW_KIT_BOM_APPROVER_LABEL.c2Approve : CONSTANTS.WOW_KIT_BOM_APPROVER_LABEL.rejected
                } else if (this.C3_APPROVED) {
                  payload.chLevel = 'C3'
                  payload.status = (type === 'APPROVED') ? CONSTANTS.WOW_KIT_BOM_APPROVER_LABEL.c3Approve : CONSTANTS.WOW_KIT_BOM_APPROVER_LABEL.rejected
                }
                const res = await http.post(`${CONSTANTS.API_URL}/api/wow-kit/update-kitSetData`, payload)
                if (res.status === 200) {
                  this.okMsg(`${payload.status} kit set successfully.`)
                  this.$emit('close')
                }
              } catch (e) {
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                return this.$dialog.error({
                  text: errorMessage,
                  title: 'Error'
                })
              }
            }
          }
        }
      })
    },
    rejectBOMKitCOnfiguration: async function (type) {
      try {
        if (_.isEmpty(this.rejectReason.trim())) {
          return this.$dialog.error({
            text: 'Rejection reason is mandatory for rejecting any entry',
            title: 'Error'
          })
        }
        let payload = {}
        payload.kitSetID = this.wowKitSetId
        if (this.C1_APPROVED) {
          payload.chLevel = 'C1'
        } else if (this.C2_APPROVED) {
          payload.chLevel = 'C2'
        } else if (this.C3_APPROVED) {
          payload.chLevel = 'C3'
        }
        payload.status = CONSTANTS.WOW_KIT_BOM_APPROVER_LABEL.rejected
        payload.reason = this.rejectReason.trim()
        const resp = await http.post(`${CONSTANTS.API_URL}/api/wow-kit/update-kitSetData`, payload)
        if (resp.status === 200) {
          this.okMsg(`${payload.status} kit set successfully.`)
          this.$emit('close')
        } else {
          this.$dialog.error({
            text: 'Failed to update status of requested wow kit set data.',
            title: 'Error'
          })
        }
        this.rejectResonDialog = false
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    getViewDetalsProductData: async function () {
      try {
        const resp = await http.get(`${CONSTANTS.API_URL}/api/wow-kit/viewdeatilslist-list?wowkitsetid=${this.wowKitSetId}&model=${this.model}`)
        if (resp.status === 200) {
          this.rejectReasonText = resp.data.reason
          this.rejectedEmailId = resp.data.rejectedBy
          this.wowKitData = {
            uploadedProductData: resp.data.uploadedProductData.length > 0 ? resp.data.uploadedProductData : [],
            previousBomData: resp.data.previousBomData.length > 0 ? resp.data.previousBomData : [],
            newlyAddedProduct: resp.data.newlyAddedProduct.length > 0 ? resp.data.newlyAddedProduct : [],
            droppedProductData: resp.data.droppedProductData.length > 0 ? resp.data.droppedProductData : []
          }
          this.getPreviousNewBomQuantity(resp.data)
        } else {
          return this.$dialog.error({
            text: 'Failed to get view details data.',
            title: 'Error'
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    getPreviousNewBomQuantity: function (resp) {
      let previousBomQuantity = _.groupBy(resp.previousBomData, 'Product_ID')
      let newBomQuantity = _.groupBy(resp.uploadedProductData, 'Product_ID')
      resp.bomQuantityUpdateData.forEach(item => {
        item.previousBomQuantity = previousBomQuantity[item.Product_ID][0].BOM_Quantity
        item.newBomQuantity = newBomQuantity[item.Product_ID][0].BOM_Quantity
      })
      this.bomProductData = resp.bomQuantityUpdateData
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    closeRejectReasonDialog: function () {
      this.rejectResonDialog = false
    }
  }
}
</script>
